import { MutationTree } from 'vuex';
import {
  StudentsState,
  StudentConditions,
  Student,
  CourseGrade,
} from '@/store/students/types';
import _ from 'lodash';
import { Pager } from '../pager.types';
import { Sort } from '../sort.types';

const mutations: MutationTree<StudentsState> = {
  /**
   * 履修者一覧を取得した
   * @param {StudentsState} state
   * @param {{
   *  condition: StudentConditions, // 履修者検索条件
   *  pager: Pager, // 履修者ページャ情報
   *  students: Student[], // 履修者一覧
   * }} payload
   */
  fetchedStudents: (state, payload: {
    conditions: StudentConditions,
    pager: Pager,
    students: Student[],
    sortBy: Sort,
  }) => {
    state.students = payload.students
    state.pager = payload.pager
    state.conditions = payload.conditions
    state.sort = payload.sortBy
  },

  /**
   * 履修者を取得した
   * @param {StudentsState} state
   * @param {Student} student セットする履修者
   */
  gotStudent: (state, student: Student) => {
    state.students = _.uniqBy([
      student,
      ...state.students,
    ], 'id')
  },

  /**
   * 履修者のコース受講履歴を取得した
   * @param {{
  *  studentId: string
  *  courseHistoryId: string
  *  courseGrade: CourseGrade
  * }} courseHistory コース受講履歴
   */
  gotStudentCourseGrade: (state, { studentId, courseHistoryId, courseGrade }: {
    studentId: string
    courseHistoryId: string
    courseGrade: CourseGrade
  }) => {
    state.courseGrades = _.uniqBy([
      { studentId, courseHistoryId, courseGrade },
      ...state.courseGrades,
    ], (ch) => `${ch.studentId}${ch.courseHistoryId}`)
  },

  /**
   * 履修者を初期化
   * @param {StudentState} state
   */
  initializeStudents: (state) => {
    state.students = []
  },
};

export default mutations;
